module.exports = __webpack_public_path__ + "static/ghost-in-the-wires-84776d2daa6a8667e4c0bbb6267b848b.jpg";